import { useState, useEffect } from "react";
import { Cookie, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookie_accepted");
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_accepted", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[100] bg-card border-t border-border/60 shadow-lg px-4 py-3 sm:px-6"
      data-testid="cookie-banner"
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
        <Cookie className="w-5 h-5 text-primary flex-shrink-0 mt-0.5 sm:mt-0 hidden sm:block" />
        <p className="font-body text-sm text-muted-foreground flex-1 leading-relaxed">
          Diese Website verwendet technisch notwendige Cookies, um die Funktionalitaet sicherzustellen.
          Es werden keine Tracking- oder Werbe-Cookies eingesetzt.
          Weitere Informationen finden Sie in unserer{" "}
          <a href="/privacy" className="text-primary hover:underline">Datenschutzerklaerung</a>.
        </p>
        <Button
          onClick={accept}
          size="sm"
          className="font-body text-sm bg-primary text-primary-foreground hover:bg-primary/90 whitespace-nowrap"
          data-testid="cookie-accept-btn"
        >
          Verstanden
        </Button>
      </div>
    </div>
  );
}
